import { DurabilitySFDRSocialEnvironmentalOnly } from '../../../../types';
export var list = [
    DurabilitySFDRSocialEnvironmentalOnly.YES,
    DurabilitySFDRSocialEnvironmentalOnly.NO,
];
